export default "__VITE_ASSET__DWMxgXjl__"